import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

// https://vuetifyjs.com/en/customization/theme/
const vuetify = new Vuetify({
  theme: {
    themes: {
      // currently copy-pasta to /src/scss/variables.scss
      light: {
        light: '#fafafb',
        darker: '#eeeeee',
        darkest: '#919191',
        primary: '#0b333b',
        secondary: '#c16e3a',
        accent: '#d6c1c8',
        info: '#ebe2d1',
        success: '#336666',
        warning: '#d7b039',
        error: '#c13949',
      },
      // I haven't implemented these updated colors yet - but wanted to store them here for reference
      ferroColors: {
        one: '#0b333b',
        two: '#d6c1c8',
        three: '#b8848e',
        four: '#ebe2d1',
        five: '#c16e3a',
        six: '#d7b039',
        seven: '#1b2652',
        eight: '#c13949',
        nine: '#336666',
        ten: '#FED8B1', // Ferro Lite
      },
      ferroOldColors: {
        one: '#df6a2e',
        two: '#003b4a',
        three: '#ede9cd',
        four: '#f5b335',
        five: '#c7868d',
        six: '#e5bec3',
        seven: '#12284c',
      },
      defaultTheme: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
})

Vue.prototype.$vuetify = vuetify.framework

export default vuetify
